module.exports = __webpack_public_path__ + "static/img/49.f39d1dc3.jpg";